"use strict";
exports.__esModule = true;
exports.SvgProofsActive = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgProofsActive = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { d: "M0 0h14v14H0z" }),
        react_1["default"].createElement("path", { fill: "#3576BA", fillOpacity: 0.3, d: "M2 5h10v7H2z" }),
        react_1["default"].createElement("path", { fill: "#3576BA", fillRule: "nonzero", d: "M12 4.5a1 1 0 011 1v5.047c0 .66-.271 1.29-.75 1.743-.482.456-1.12.71-1.783.71H2a1 1 0 01-1-1V5.5a1 1 0 011-1h10zM11.5 6h-9v5.5h7.967c.233 0 .459-.074.645-.21l.107-.09a.897.897 0 00.273-.53l.008-.123V6zm-1.206-4c.39 0 .706.336.706.75 0 .38-.266.693-.61.743l-.096.007H3.706C3.316 3.5 3 3.164 3 2.75c0-.38.266-.693.61-.743L3.706 2h6.588z" })))); };
//# sourceMappingURL=ProofsActive.js.map